var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "local") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-590.000000, -6013.000000)",
    stroke: "",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy-2",
    transform: "translate(162.000000, 5902.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "local",
    transform: "translate(429.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00000465,9.71787854 C5.60115718,9.71787854 4.46716737,8.53024106 4.46716737,7.06521584 C4.46716737,5.60019061 5.60115718,4.41255273 7.00000465,4.41255273 C8.39885211,4.41255273 9.53284192,5.60019061 9.53284192,7.06521584 C9.53284192,8.53024106 8.39885211,9.71787854 7.00000465,9.71787854 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8029539,5.52638286 C14.7365317,9.84546198 12.1712223,13.5013758 9.92251736,15.762941 C8.2907856,17.4123531 5.70923976,17.4123531 4.06938994,15.762941 C1.82880304,13.5013758 -0.736506964,9.83695966 0.197070894,5.51788054 C1.79633041,-1.84495902 12.2118124,-1.83645671 13.8029539,5.52638286 Z",
    id: "Vector",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.3442cfe45b74109cc66c8c01f25b0b33.svg";
export { ForwardRef as ReactComponent };